import React from 'react';
import { Box } from '@mui/material';
import SocialMedia from './SocialMedia';
import { socialMediaIconUrls } from '../../config/socialMediaIcons';
import { socialMediaLinks } from '../../config/socialMediaLinks';

interface SocialMediaListProps {
}

const SOCIAL_COLORS = {
    instagram: '#E4405F',
    facebook: '#1877F2',
    youtube: '#FF0000',
    tiktok: '#25F4EE',
} as const;

const SocialMediaList: React.FC<SocialMediaListProps> = () => {
    return (
        <Box display="flex" flexDirection="row" gap={1}>
            <SocialMedia link={socialMediaLinks.instagram} borderColor={SOCIAL_COLORS.instagram} icon={<Box component="img" src={socialMediaIconUrls.instagram()} alt="Instagram" sx={{ width: 24, height: 24, objectFit: 'contain' }} />} />
            <SocialMedia link={socialMediaLinks.facebook} borderColor={SOCIAL_COLORS.facebook} icon={<Box component="img" src={socialMediaIconUrls.facebook()} alt="Facebook" sx={{ width: 24, height: 24, objectFit: 'contain' }} />} />
            <SocialMedia link={socialMediaLinks.youtube} borderColor={SOCIAL_COLORS.youtube} icon={<Box component="img" src={socialMediaIconUrls.youtube()} alt="YouTube" sx={{ width: 24, height: 24, objectFit: 'contain' }} />} />
            <SocialMedia
                link={socialMediaLinks.tiktok}
                borderColor={SOCIAL_COLORS.tiktok}
                icon={<Box component="img" src={socialMediaIconUrls.tiktok()} alt="TikTok" sx={{ width: 24, height: 24, objectFit: 'contain' }} />}
            />
        </Box>
    );
};

export default SocialMediaList;